import React, { useEffect, useState } from "react";
import "./index.scss";
import PageHeader from "../../../adminCompenents/listComponents/Layout";
import CardContainer from "../../../adminCompenents/listComponents/UI/CardContainer";
import ExportButton from "../../../adminCompenents/listComponents/UI/ExportButton";
import AddButton from "../../../adminCompenents/listComponents/UI/AddButton";
import DataTable from "../../../adminCompenents/listComponents/UI/DataTable";
import DataCards from "../../../adminCompenents/listComponents/UI/DataCards";
import Pagination from "../../../adminCompenents/listComponents/UI/Pagination";
import DrawerForm from "../../../adminCompenents/listComponents/UI/DrawerForm";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import { exportCSV } from "../../../adminCompenents/utils";
import ImageCategoryService from "../../../services/imageCategory";
// Nouveau service

const imageCategoryService = new ImageCategoryService();

const ImageCategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 5;
  const [isMobile, setIsMobile] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);

  // Responsive detection
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Charger les images categories
  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await imageCategoryService.getAll();
      setCategories(res?.data || []);
    } catch (error) {
      showErrorToaster(error.response?.data?.message || "Erreur chargement");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const totalPages = Math.ceil(categories.length / perPage);
  const paginated = categories.slice((page - 1) * perPage, page * perPage);

  const apiUrl = process.env.REACT_APP_API_URL;
  const getImageURL = (imageName) =>
    `${apiUrl}/image-category/${imageName}/image`;

  const handleSubmit = async (formData, editCategory = null) => {
    try {
      const formDataToSend = new FormData();
      if (formData.image) formDataToSend.append("image", formData.image);

      if (editCategory) {
        // Édition
        const updated = await imageCategoryService.update(
          editCategory._id,
          formDataToSend
        );
        console.log(updated);

        setCategories((prev) =>
          prev.map((c) => (c._id === editCategory._id ? updated.data : c))
        );
        console.log(categories);
        showSuccessToaster("Image catégorie modifiée avec succès.");
      } else {
        // Création
        const newCat = await imageCategoryService.create(formDataToSend);
        setCategories((prev) => [...prev, newCat.data]);
        showSuccessToaster("Image catégorie créée avec succès.");
      }

      setShowDrawer(false);
      setEditCategory(null);
    } catch (error) {
      showErrorToaster(
        error.response?.data?.message || "Erreur, veuillez réessayer."
      );
    }
  };
  console.log(categories);
  const columns = [
    {
      header: "Image",
      accessor: "image",
      Cell: (value, row) => (
        <div className="d-flex align-items-center">
          <img
            src={getImageURL(row?._id)}
            alt={row.name}
            className="product-img me-2"
          />
          {value}
        </div>
      ),
    },
  ];

  const rowActions = (row) => [
    {
      label: "Edit",
      onClick: () => {
        setEditCategory({
          ...row,
          image: getImageURL(row._id), // ✅ transformer en URL utilisable
        });
        setShowDrawer(true);
      },
    },
  ];

  const fields = [
    {
      name: "image",
      label: "Image de la catégorie",
      type: "file",
      required: true,
    },
  ];

  return (
    <div>
      <PageHeader
        title="Image de catégorie"
        breadcrumb={[{ label: "Accueil", href: "/" }, { label: "Image Category" }]}
      />

      <CardContainer>
        <div className="d-flex justify-content-between align-items-center mb-3 m-4">
          <h5 className="title-liste">Image de catégorie</h5>
        </div>

        <hr className="hr-table" />

        {isMobile ? (
          <DataCards
            columns={columns}
            data={paginated}
            keyField="_id"
            rowActions={rowActions}
          />
        ) : (
          <DataTable
            columns={columns}
            data={paginated}
            keyField="_id"
            rowActions={rowActions}
          />
        )}

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </CardContainer>

      <DrawerForm
        show={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setEditCategory(null);
        }}
        title={editCategory ? "Modifier l'image" : "Ajouter une image"}
        fields={fields}
        initialData={editCategory}
        onSubmit={(data) => handleSubmit(data, editCategory)}
      />
    </div>
  );
};

export default ImageCategoryPage;
